module.exports = __webpack_public_path__ + "fa-regular-400.7630483dd4b0c48639d2.eot";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.eot
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-regular-400.eot
// module chunks = styles